import styled from "@emotion/styled";

export const StyledBlogs = styled.div`
  .blogs {
    padding: 20px 20px 20px 20px;
  }

  .loading {
    height: calc(100dvh - 300px);
  }
  .not-found {
    margin: 100px 0px;
  }

  .page-title {
    text-align: center;
    margin-bottom: 32px;
    margin-top: 100px;
  }

  .blog-card {
    cursor: pointer;
    overflow: hidden;
  }

  .blog-image {
    width: 100%;
    height: 270px;
    object-fit: cover;
    border-radius: 12px;
  }

  .blog-title {
    font-size: 20px;
    font-weight: bol;
    margin-top: 10px;
    word-break: break-word;
    overflow-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.5;
    min-height: 3em;
    color: #000;
  }

  @media (max-width: 768px) {
    .blog-image {
      height: 180px;
    }
    .not-found {
      margin: 50px 0px;
    }
  }
`;

export const StyledBlogDetail = styled.div`
  .blog-detail {
    max-width: 1200px;
    margin: 0 auto;
    padding: 100px 24px 24px 24px;
  }

  .loading {
    height: calc(100dvh - 300px);
  }
  .not-found {
    margin: 100px 0px;
  }

  .detail-image {
    width: 100%;
    max-height: 500px;
    object-fit: cover;
    border-radius: 8px;
  }

  .detail-title {
    font-size: 28px;
    font-weight: 700;
    margin: 20px 0;
  }

  .detail-description {
    line-height: 1.8;
    font-size: 16px;
  }

  .detail-description img {
    max-width: 100%;
  }

  @media (max-width: 768px) {
    .blog-image {
      height: 300px;
    }
    .not-found {
      margin: 50px 0px;
    }
  }
`;
